import React from 'react';
import styled from 'styled-components';

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  wrap-content: true;
  overflow: hidden;
  max-width: 20%;
  max-height: 100%;
`;

const Logo = () => (
  <LogoWrapper aria-label="Homepage" tabIndex={0}>
    <a href="/">
      <img 
        src={require('../images/headerLogo.jpg')} 
        alt="Company Logo" 
        className="logo" 
        style={{
          maxWidth: '75%',
          maxHeight: '75%'
        }}
      />
    </a>
  </LogoWrapper>
);

export default Logo;
